import React from 'react';
import { Box, Title, Text, Group, useMantineTheme } from '@mantine/core';

export default function Module({
  title,
  subtitle,
  children,
  icon: IconComponent,
  titleExtra,
  subtitleExtra,
  contentMt = 'md',
}) {
  const theme = useMantineTheme();
  const palette = theme.colors[theme.primaryColor] || theme.colors.teal;
  const hasHeader = title || subtitle;

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      {hasHeader && (
        <Box
          style={{
            flexShrink: 0,
            paddingBottom: 8,
            paddingTop: 8,
          }}
        >
          {title && (
            <Group justify="space-between" align="center" wrap="nowrap" gap="sm">
              <Title order={2} style={{ flex: 1, minWidth: 0 }}>
                <Group gap="sm" wrap="nowrap">
                  {IconComponent && (
                    <IconComponent size={32} color={palette[7]} stroke={1.5} />
                  )}
                  {title}
                </Group>
              </Title>
              {titleExtra ? <Box style={{ flexShrink: 0 }}>{titleExtra}</Box> : null}
            </Group>
          )}
          {(subtitle || subtitleExtra) && (
            <Group gap={6} wrap="nowrap" align="center" mt={4} ml={IconComponent ? 44 : 0}>
              {subtitle ? <Text c="dimmed">{subtitle}</Text> : null}
              {subtitleExtra}
            </Group>
          )}
        </Box>
      )}
      <Box
        mt={hasHeader ? contentMt : 0}
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
